"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.protoChain = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Return an array of constructor function names based on the prototype chain
 *
 * @param {Object}    source  Source input
 * @param {string[]}  acc     Accumulator array
 *
 * @returns {string[]}
 *
 * @tag Core
 * @signature (source: Object, acc: string[]): string[]
 */
var protoChain = function protoChain(source) {
  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var proto = Object.getPrototypeOf(source);
  return proto ? protoChain(proto, [].concat(_toConsumableArray(acc), [proto.constructor.name])) : acc;
};

exports.protoChain = protoChain;